import { auth } from "src/util/firebase";
import axios, { InternalAxiosRequestConfig } from "axios";

axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;

// Store authorized user ID globally
let authorizedUserId: string | null = null;

// Export function to set authorized user
export function setAuthorizedUser(userId: string | null) {
  authorizedUserId = userId;
}

axios.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  if (config.url?.startsWith("/v2")) {
    config.baseURL = import.meta.env.VITE_API_V2_BASE_URL;
  } else {
    config.baseURL = import.meta.env.VITE_API_BASE_URL;
  }
  if (authorizedUserId) {
    config.headers.set("X-Authorized-User", authorizedUserId);
  }
  try {
    // Only attempt to get token if we have a current user
    if (auth.currentUser) {
      const token = await auth.currentUser.getIdToken();
      if (token) {
        config.headers.set("Authorization", "Bearer " + token);
      }
    }
  } catch (error) {
    console.error("Error getting auth token:", error);
  }
  return config;
});
